import networkCallWrapper from "../utils/networkCallWrapper";

const sendEddData = async (eddData: any) =>
  await networkCallWrapper({
    url: "v2/limits/edd/data",
    method: "POST",
    service: "wallet",
    data: eddData
  });

export default sendEddData;
